<template>
    <div v-if="isNotRemovedHost" @click="removeHost" class="remove-host-btn">
        <i class="fas fa-times"></i>
    </div>
</template>

<script>
import axios from 'packs/axios'

export default {
   props: ["userId"],
  data() {
    return {
      isNotRemovedHost: false
    };
  },
  created() {
    this.isNotRemovedHost = true
  },
  methods: {
    removeHost: async function() {
      const res = await axios.patch('/api/v1/viewed_hosts', { user_id: this.userId })
      if (res.status !== 200) {
        window.alert(res.data.message)
        process.exit()
      }
      this.isNotRemovedHost = false
      document.getElementById(`viewed-host-user--${this.userId}`).remove()

      //　該当のユーザーがなければメッセージを表示
      if (document.querySelector("div .viewed-host") == null) {
        document.getElementById('viewed-hosts-wrapper').innerHTML = `
          <div class="content-not-found content-not-found--white">
            該当のユーザーはまだいません
          </div>`
      }
      //　件数が少なければ最終件にアンダーラインを追加
      const sectionStyle = window.getComputedStyle(document.getElementById("section__inner-bg"))
      if (parseInt(sectionStyle.getPropertyValue("height")) == 420) {
        $(".viewed-host").last().css("border-bottom", "1px solid #eee")
      }
    },
  }
}
</script>